import React from 'react'
import { useStaticQuery, graphql } from "gatsby"
import moment from 'moment'

import Layout from '../../layouts'
import LargeHero from '../../components/elements/largeHero'
import { Body, SizedText, Canon } from '../../components/elements/typography'
import Grid from '../../components/elements/grid'
import SEO from "../../components/elements/seo"

const HolidaysPage = () => {

  const data = useStaticQuery(graphql`
  query HolidaysQuery {
    allSettingsHolidaysYaml {
      nodes {
        holiday
        fed
        date
        tcb
      }
    }
  }
  
`)

const holidaysData = data.allSettingsHolidaysYaml.nodes.map(i => (
  <div key={i.id} className="idTable" >
    <div className="tCell">
      {i.holiday} <br />
      {moment(i.date).format("dddd, MMMM Do")}
    </div>
    <div className="tCell">{i.tcb}</div>
    <div className="tCell">{i.fed}</div>
  </div>
))

  return (
    <Layout isSubMenuOpen={true} openAccountLink={true}>
       <LargeHero.Container
        padding="3rem 0 4rem 0"
        background={{
          backgroundImage: `url(/images/background-deltas.jpg)`, 
          backgroundRepeat: `no-repeat`, 
          backgroundAttachment: `scroll`, 
          backgroundPosition: `top left`, 
          backgroundSize: `cover`,
        }}
        breadcrumbLinks={[
          { path: "/", text: "Home" },
          { path: "/about/", text: "About Us" },
          { path: "/about/holidays-and-cutoffs", text: "Holiday Hours & Cutoff Times" },
        ]}
        styles={{
          paddingBottom: `5rem`,
          overflow: `hidden`,
          '.breadcrumbs, .breadcrumbs [aria-current="page"]': {color: `#fff`},
          '.heroContent': { paddingBottom: `3rem`},
          '@media (min-width: 680px)': {
            '.heroContent': { width: `100% !important`, marginBottom: `0`},
          }
        }}
      >
        <LargeHero.Content styles={{paddingTop: `1rem`, color: `#fff`}}>
          <h1 css={{fontFamily: `Proxima-nova`, textTransform: `uppercase`,  'span': {display: `block`, lineHeight: `1`, padding: `0.5rem 0`}}}>
            <SizedText as="span" smallSize="2.281" largeSize="4.624">Holiday Hours & Cutoff Times</SizedText>
          </h1>
        </LargeHero.Content>
      </LargeHero.Container>

      {/* --- HOLIDAYS --- */}
      <Grid.FullWidthSection css={{padding: `6rem 0`}}>
        <Grid.Block start={['2', '2', '2', '2', '2', '3']} span={['12', '12', '12', '12', '12', '10']}>
          <Canon>2022 Federal Reserve and TCB Holiday Schedule</Canon>
          <Body>
            Our branches will be closed on in observance of the following
            federal holidays so that TCB team members can spend time with their
            friends and families. If you need to handle banking during the
            holidays, you can access your accounts anywhere anytime through our
            secure online and mobile banking apps.
          </Body>
        </Grid.Block>
        <Grid.Block start="3" span="10">
        <div css={{
            '.idTable': {
              display:  `grid`,
              gridTemplateColumns: `1fr`, 
              borderBottom: `1px solid  rgb(90, 102, 115)`,
              '@media (min-width: 950px)': { gridTemplateColumns: `2fr 1fr 1fr`, borderBottom: `none`,},
              'div': { 
                padding: `1rem`,
                borderBottom: `none `,
              },
              '.tHead': { 
                backgroundColor: `slategray !important`,
                border: `1px solid  rgb(90, 102, 115)`,
                'h2': {
                  margin: `0`,
                  padding: `0`,
                  color: `#fff`,
                }
              },
              '.tCell': { 
                backgroundColor: `#fff`,
                border: `1px solid #ecf0f1`,
              },
            }
          }}>
        
            <div css={{border: `1px solid  rgb(90, 102, 115)`,}}>
            <div className="idTable">
              <div className="tHead"><SizedText as="h2" smallSize="1.125" largeSize="1.125">Holiday</SizedText></div>
              <div className="tHead"><SizedText as="h2" smallSize="1.125" largeSize="1.125">TCB</SizedText></div>
              <div className="tHead"><SizedText as="h2" smallSize="1.125" largeSize="1.125">Federal Reserve</SizedText></div>
            </div>
              {holidaysData}
            </div>
          </div>
          <Body>
           * For holidays falling on Saturday, TCB and Federal Reserve Banks and Branches will be open the preceding Friday. <br />
           ** For holidays falling on Sunday, TCB and Federal Reserve Banks and Branches will be closed the following Monday — June 20, 2022, December 26, 2022.
          </Body>
        </Grid.Block>
      </Grid.FullWidthSection>

      {/* --- ACH PROCESSING --- */}
      <Grid.FullWidthSection css={{}}>
        <Grid.Block start={['2', '2', '2', '2', '2', '3']} span={['12', '12', '12', '12', '12', '10']}>
          <Canon>ACH Processing Deadlines</Canon>
          <Body>The following are final cutoff times for each ACH (Automated Clearing House) product.</Body>

          <div css={{
            '.idACHTable': {
              display:  `grid`,
              gridTemplateColumns: `1fr`, 
              borderBottom: `1px solid  rgb(90, 102, 115)`,
              '@media (min-width: 950px)': { gridTemplateColumns: `2fr 1fr`, borderBottom: `none`,},
              'div': { 
                padding: `1rem`,
                borderBottom: `none `,
              },
              '.tHead': { 
                backgroundColor: `slategray !important`,
                border: `1px solid  rgb(90, 102, 115)`,
                'h2': {
                  margin: `0`,
                  padding: `0`,
                  color: `#fff`,
                }
              },
              '.tCell': { 
                backgroundColor: `#fff`,
                border: `1px solid #ecf0f1`,
              },
            }
          }}>
        
            <div css={{border: `1px solid  rgb(90, 102, 115)`,}}>
            <div className="idACHTable">
              <div className="tHead"><SizedText as="h2" smallSize="1.125" largeSize="1.125">ACH Product</SizedText></div>
              <div className="tHead"><SizedText as="h2" smallSize="1.125" largeSize="1.125">Final Cutoffs</SizedText></div>
            </div>

            <div className="idACHTable" >
              <div className="tCell">BusinessGo Same Day ACH</div>
              <div className="tCell">11 AM EST</div>
            </div>

            <div className="idACHTable" >
              <div className="tCell">BusinessGo Traditional Next Day ACH</div>
              <div className="tCell">4:30 PM EST</div>
            </div>

            </div>
          </div>

          <Body>
            As a reminder, debit files must be delivered to TCB no later than 1
            business day prior to the effective date. Credit files are
            recommended to be delivered 2 business days prior to the effective
            date. 
            <br />
            Please call TCB Treasury Management Client Support at 912-739-3322
            if you have questions about the TCB ACH Processing Schedule.
          </Body>

        </Grid.Block>
      </Grid.FullWidthSection>

      {/* --- Other Cutoffs --- */}
      <Grid.FullWidthSection css={{padding: `6rem 0`}}>
        <Grid.Block start={['2', '2', '2', '2', '2', '3']} span={['12', '12', '12', '12', '12', '10']}>
          <Canon>Other Processing Deadlines</Canon>
          
          <div css={{
            '.idACHTable': {
              display:  `grid`,
              gridTemplateColumns: `1fr`, 
              borderBottom: `1px solid  rgb(90, 102, 115)`,
              '@media (min-width: 950px)': { gridTemplateColumns: `2fr 1fr `, borderBottom: `none`,},
              'div': { 
                padding: `1rem`,
                borderBottom: `none `,
              },
              '.tHead': { 
                backgroundColor: `slategray !important`,
                border: `1px solid  rgb(90, 102, 115)`,
                'h2': {
                  margin: `0`,
                  padding: `0`,
                  color: `#fff`,
                }
              },
              '.tCell': { 
                backgroundColor: `#fff`,
                border: `1px solid #ecf0f1`,
              },
            }
          }}>
        
            <div css={{border: `1px solid  rgb(90, 102, 115)`,}}>
            <div className="idACHTable">
              <div className="tHead"><SizedText as="h2" smallSize="1.125" largeSize="1.125">TCB Product</SizedText></div>
              <div className="tHead"><SizedText as="h2" smallSize="1.125" largeSize="1.125">Final Cutoffs</SizedText></div>
            </div>

            <div className="idACHTable" >
              <div className="tCell">Domestic Wire Transfers</div>
              <div className="tCell">
                3:30 PM EST <small>(Monday, Tuesday, Wednesday)</small><br />
                11:00 AM EST <small>(Thursday)</small><br />
                5:00 PM EST <small>(Friday)</small><br />
              </div>
            </div>

            <div className="idACHTable" >
              <div className="tCell">International Wire Transfers</div>
              <div className="tCell">
                3:30 PM EST <small>(Monday, Tuesday, Wednesday)</small><br />
                11:00 AM EST <small>(Thursday)</small><br />
                4:00 PM EST <small>(Friday)</small><br />
              </div>
            </div>

            <div className="idACHTable" >
              <div className="tCell">Mobile Deposit Capture</div>
              <div className="tCell">
                2:00 PM EST <small>(Monday, Tuesday, Wednesday, Friday)</small><br />
                11:00 AM EST <small>(Thursday)</small>
              </div>
            </div>

            <div className="idACHTable" >
              <div className="tCell">Merchant Remote Deposit Capture</div>
              <div className="tCell">
                3:00 PM EST <small>(Monday, Tuesday, Wednesday, Friday)</small><br />
                11:00 AM EST <small>(Thursday)</small>
              </div>
            </div>

            <div className="idACHTable" >
              <div className="tCell">TCB Automatic BillPay</div>
              <div className="tCell">4:30 PM EST</div>
              
            </div>

            <div className="idACHTable" >
              <div className="tCell">
                Internal Transfers to Credit Accounts<br />
                <small>(credit card, lines of credit, installment loan or mortgage accounts)</small>
              </div>
              <div className="tCell">11:59 PM EST on a bank business day for same-day credit.</div>
            </div>

            <div className="idACHTable" >
              <div className="tCell">
                Internal Transfers to Deposit Accounts<br />
                <small>(checking, savings, money market accounts)</small>
              </div>
              <div className="tCell">All transfers are credited immediately.</div>
            </div>

            </div>
          </div>
        </Grid.Block>
      </Grid.FullWidthSection>
    </Layout>
  )
}

export default HolidaysPage